import type { Attribution } from "../../shared/types";
import type { LanderConfig } from "./landers";

function take(params: URLSearchParams, name: string, max = 250) {
  const value = params.get(name)?.trim();
  return value ? value.slice(0, max) : undefined;
}

export function attributionFromLocation(config: LanderConfig): Attribution {
  const params = new URLSearchParams(window.location.search);
  return {
    utmSource: take(params, "utm_source"),
    utmMedium: take(params, "utm_medium"),
    utmCampaign: take(params, "utm_campaign"),
    utmTerm: take(params, "utm_term"),
    utmContent: take(params, "utm_content"),
    msclkid: take(params, "msclkid"),
    tblci: take(params, "tblci") || take(params, "taboola_click_id"),
    gclid: take(params, "gclid"),
    fbclid: take(params, "fbclid"),
    landerId: config.id,
    landingPath: window.location.pathname,
    referrer: document.referrer.slice(0, 500) || undefined,
    taboolaCampaignId: take(params, "taboola_campaign_id"),
    taboolaItemId: take(params, "taboola_item_id"),
    taboolaSiteId: take(params, "taboola_site_id"),
    taboolaSite: take(params, "taboola_site"),
    taboolaPlatform: take(params, "taboola_platform"),
  };
}
